import { IAct } from '@gongxigames/framework/slotV2/fsm/stateMachineTypes';

export class Act implements IAct{

    protected _isSkipped = false;

    public executeSkipOnRoot?: () => void;
    public executeSyncInternalFunc?: () => void;

    constructor() {
        this.executeSkipOnRoot = this.executeSkip.bind(this);
    }

    // protected _executeSkip!: () => void;
    protected onExecuted?: () => void;

    /**
     * this function is called when queue state was interrupted
     * and this act is current
     */
    public async skip(): Promise<void> {

    }

    /**
     * this function is called if queue state was interrupted
     * before executing this act
     */
    public async forceSkip(): Promise<void> {

    }

    /**
     * this function is called when normal queue state is executing
     */
    execute(onExecuted: () => void): void {
        this.onExecuted = () => {
            onExecuted();
            this.onExecuted = undefined;
        };
        this.isSkipped = false;

        if (this.executeSyncInternalFunc) {
            this.executeSyncInternalFunc();
        } else {
            this
                .executeInternal()
                .then(() => {
                    !this.isSkipped && this.onExecuted?.();
                });
        }
    }

    private executeSkip(): void {
        if (!this.isSkipped) {
            this.isSkipped = true;
            // consoleLogger.log(`Skip state ===> ${this.name}`);
            this.skip();
        }
    }

    protected async executeInternal(): Promise<void> {
    }

    public removeAllEventListeners(): void {
    }

    public set isSkipped(value: boolean) {
        this._isSkipped = value;
    }

    public dispose(): void {
        this.removeAllEventListeners();
    }
}